import Model from './Model';

export default class PointOfInterest extends Model {
  resource() {
    return 'point-of-interests';
  }
}
